import {
  Add_Campaign_Type,
  Delete_Campaign_Type,
  Get_All_Campaign_Type,
  Get_Campaign_Reports_Type,
  Get_Error,
  Get_One_Campaign_Type,
  Update_One_Campaign_Type,
} from '../Types';

const intial = {
  campaign: [],
  updatecampaign: [],
  getcampaign: [],
  loading: true,
};

const Campaign_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_Campaign_Type:
      return {
        ...state,
        campaign: action.payload,
        loading: false,
      };
    case Get_All_Campaign_Type:
      return {
        ...state,
        campaign: action.payload,
        loading: false,
      };
    case Delete_Campaign_Type:
      return {
        ...state,
        campaign: action.payload,
        loading: false,
      };
    case Get_One_Campaign_Type:
      return {
        ...state,
        getcampaign: action.payload,
        loading: false,
      };
    case Update_One_Campaign_Type:
      return {
        ...state,
        updatecampaign: action.payload,
        loading: false,
      };
    case Get_Campaign_Reports_Type:
      return {
        ...state,
        campaign: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        campaign: action.payload,
      };
    default:
      return state;
  }
};

export default Campaign_Reducer;
